import axios from 'axios';
import BaseAPI from './base/base-api';

class UserTaxAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'users';
}

export default new UserTaxAPI();